import makeFormRequest from "../../../../helpers/form-request.js";
import LoginForm from "../components/login-form.js";
export default {
    execute: async () => {
        const { form, submitBtn } = LoginForm.get();
        const formRequest = makeFormRequest({ form, submitBtn });
    }
};
